import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
};

const BurgerNavWrapper: React.FC<Props> = ({
    children,
}) => {
    const theme = useTheme();

    const style = css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: ${theme.sizes.menu.burgerHeightMain}px;
        
        ${theme.breakpoints.only("lg")} {
            // 6px: Button div padding
            padding-right: calc(${theme.sizes.menu.sideMargin}px - 6px);
        }
        
        ${theme.breakpoints.down("lg")} {
            justify-content: space-between;
        }
    `;

    return (
        <div css={style}>
            {children}
        </div>
    );
};

export default BurgerNavWrapper;